import AEMWrapper from "aem/ComponentWrapper";
import { AEMComponentProps } from "aem/types";
import React, { FC } from "react";
import { getGlobal } from "@RHCommerceDev/utils-globals/getGlobal";
import { useMediaQuery, Theme } from "@mui/material";
import Header from ".";

export type AEMHeaderProps = AEMComponentProps & {
  desktopColorStyle: string;
  desktopPosition: "relative" | "absolute";
  mobileColorStyle: string;
  mobilePosition: "relative" | "absolute";
  mobileBackgroundColorStyle: string;
  desktopBackgroundColorStyle: string;
  paddingBottom: string;
};

const env = getGlobal("_env");

const Component: FC<AEMHeaderProps> = ({
  desktopColorStyle = "White",
  desktopPosition = "relative",
  mobileColorStyle = "White",
  mobilePosition = "relative",
  mobileBackgroundColorStyle = "transparent",
  desktopBackgroundColorStyle = "transparent",
  ...rest
}) => {
  const mdUp = useMediaQuery<Theme>(theme => theme.breakpoints.up("md"));

  const mobileBg =
    mobileBackgroundColorStyle === "White Gradient"
      ? "linear-gradient(to bottom, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.44) 59%, rgba(0,0,0,0) 100%"
      : mobileBackgroundColorStyle;
  const desktopBg =
    desktopBackgroundColorStyle === "White Gradient"
      ? "linear-gradient(to bottom, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.44) 59%, rgba(0,0,0,0) 100%"
      : desktopBackgroundColorStyle;

  const position = mdUp ? desktopPosition : mobilePosition;
  const background = mdUp ? desktopBg : mobileBg;
  const color = mdUp ? desktopColorStyle : mobileColorStyle;

  return (
    <>
      <Header
        {...rest}
        RHRHeaderProps={{
          RHRHeaderContentProps: {
            styles: {
              root: {
                position,
                background,
                color
              }
            }
          }
        }}
      />
    </>
  );
};

export default AEMWrapper(
  {
    type: "rh/components/content/globalheader",
    config: {
      emptyLabel: "GlobalHeader",
      isEmpty: _ => false
    }
  },
  Component
);
